goog.provide("shadow.js.shim.module$$mui$material$MenuList");
goog.provide("module$shadow_js_shim_module$$mui$material$MenuList");
shadow.js.shim.module$$mui$material$MenuList = shadow.js.nativeProvides["@mui/material/MenuList"] = shadow$bridge("@mui/material/MenuList");
module$shadow_js_shim_module$$mui$material$MenuList.default = shadow.js.shim.module$$mui$material$MenuList;
